import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { callAfterNextAnimationFrame } from '../../util/callAfterNextAnimationFrame';
/* An input that always sends updates to its parent, and always reflects value prop
 */

var ControlledBlurInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ControlledBlurInput, _React$Component);

  function ControlledBlurInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      focused: false,
      value: ''
    };

    _this.handleKeyPress = function (e) {
      if (e.key === 'Enter' && !_this.props.textarea) {
        if (_this.props.onBlur) {
          _this.props.onBlur(e);
        }

        e.target.blur();
      }

      if (_this.props.onKeyPress) {
        _this.props.onKeyPress(e);
      }
    };

    _this.handleFocus = function (e) {
      // Initialize local value state when the input gains focus.
      if (_this.state.value !== _this.props.value) {
        _this.setState({
          value: _this.props.value
        });
      }

      if (!_this.state.focused) {
        _this.setState({
          focused: true
        });
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    };

    _this.handleBlur = function (e) {
      if (_this.state.focused) {
        _this.setState({
          focused: false
        });
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
    };

    _this.onChange = function (e) {
      // Keep track of value changes locally.
      if (_this.state.value !== e.target.value) {
        _this.setState({
          value: e.target.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };

    _this.forceInputBlur = function () {
      // check to see if DOM value differs from React state value
      // only trigger handleBlur when input does NOT have focus
      if (!_this.input || _this._previousValue === _this.input.value || _this.input === document.activeElement) {
        return;
      }

      _this._previousValue = _this.input.value; // manually trigger input event

      var evt = document.createEvent('HTMLEvents');
      evt.initEvent('input', true, true);

      _this.input.dispatchEvent(evt);

      _this.handleBlur(evt);
    };

    _this.refInput = function (input) {
      _this.input = input;

      if (_this.props.onSetInput) {
        _this.props.onSetInput(input);
      }
    };

    return _this;
  }

  var _proto = ControlledBlurInput.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var autoComplete = this.props.autoComplete;
    var isAutoCompleteOff = /^(false|off)$/.test(autoComplete); // input change workaround for browser autofill should be
    // triggered only if autoComplete is specified and is
    // something other than 'false', 'off'.

    if (autoComplete && !isAutoCompleteOff) {
      callAfterNextAnimationFrame(this.forceInputBlur);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this._listener);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        component = _this$props.component,
        textarea = _this$props.textarea,
        onSetInput = _this$props.onSetInput,
        controlledEditing = _this$props.controlledEditing,
        _this$props$autoCompl = _this$props.autoComplete,
        autoComplete = _this$props$autoCompl === void 0 ? 'off' : _this$props$autoCompl,
        otherProps = _objectWithoutProperties(_this$props, ["component", "textarea", "onSetInput", "controlledEditing", "autoComplete"]); // We do not want to reflect the value prop while the input has focus;
    // use the local state value unless controlledEditing is enabled.


    var value = this.props.value;

    if (this.state.focused && !this.props.controlledEditing) {
      value = this.state.value;
    } // The value prop must always have a value, otherwise it switches this to
    // an uncontrolled input.


    if (typeof value === 'undefined' || value === null) {
      value = '';
    }

    var props = Object.assign({}, otherProps, {
      autoComplete: autoComplete,
      value: value,
      ref: this.refInput,
      onKeyPress: this.handleKeyPress,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.onChange
    });
    var Component = component;

    if (typeof component === 'function') {
      Component = component(this.props);
    }

    return /*#__PURE__*/React.createElement(Component, props);
  };

  return ControlledBlurInput;
}(React.Component);

export { ControlledBlurInput as default };
ControlledBlurInput.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onSetInput: PropTypes.func,
  controlledEditing: PropTypes.bool,
  value: PropTypes.string,
  textarea: PropTypes.bool,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string
} : {};
ControlledBlurInput.defaultProps = {
  component: function component(_ref) {
    var textarea = _ref.textarea;
    return textarea ? 'textarea' : 'input';
  }
};